import { Components, SxProps, Theme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    inverse: true;
  }
}

// MUI fixes a chip at 32px. The design's status badge is 28px: 4px padding
// around a 20px line, with a 16px icon.
export const badgeChipSx = {
  height: 'auto',
  padding: '4px 8px',
  '& .MuiChip-icon': {
    fontSize: '16px'
  }
} satisfies SxProps<Theme>;

export const chipStyles: Components<Theme>['MuiChip'] = {
  defaultProps: {
    deleteIcon: <CloseIcon />
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      let primaryColor = theme.palette.customGrey.dark;
      let secondaryColor = theme.palette.white;

      if (ownerState.color === 'primary') {
        primaryColor = theme.palette.primary.main;
        secondaryColor =
          ownerState.variant === 'inverse'
            ? theme.palette.primary.light
            : theme.palette.white;
      } else if (ownerState.color === 'secondary') {
        primaryColor = theme.palette.primary.light;
        secondaryColor = theme.palette.primary.main;
      } else if (ownerState.color === 'error') {
        primaryColor = theme.palette.error.light;
        secondaryColor = theme.palette.error.main;
      } else if (ownerState.color === 'warning') {
        primaryColor = theme.palette.warningV2.light;
        secondaryColor = theme.palette.warningV2.dark;
      } else if (ownerState.color === 'info') {
        primaryColor = theme.palette.customGrey.light;
        secondaryColor = theme.palette.customGrey.medium;
      } else if (ownerState.color === 'success') {
        primaryColor = theme.palette.successV2.light;
        secondaryColor = theme.palette.successV2.main;
      }

      let backgroundColor = primaryColor;
      let textColor = secondaryColor;
      let borderColor = primaryColor;

      if (ownerState.variant === 'outlined') {
        backgroundColor = 'transparent';
        textColor = primaryColor;
        borderColor = primaryColor;
      } else if (ownerState.variant === 'inverse') {
        backgroundColor = secondaryColor;
        textColor = primaryColor;
        borderColor = 'none';
      }

      return {
        borderRadius: 20,
        backgroundColor,
        color: textColor,
        border:
          ownerState.variant === 'outlined'
            ? `1px solid ${borderColor}`
            : 'none',
        display: 'flex',
        gap: '4px',
        padding: '4px 12px',
        '& .MuiChip-label': {
          padding: 0,
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px'
        },
        '& .MuiChip-icon': {
          fontSize: '14px',
          margin: 0
        },
        '& .MuiChip-deleteIcon': {
          fontSize: '14px',
          margin: 0,
          color: `${textColor} !important`,
          '& svg': {
            fontSize: '14px'
          }
        }
      };
    }
  }
};
